/**
 * SummoningAnimation.tsx
 *
 * The flagship loading animation used while content is being generated
 * (a single carousel in DistillPageV2, or all the posts of a LinkedIn
 * campaign in CampaignPlannerPage).
 *
 * Styling lives in `frontend/src/landing.css` under the `.carousel-summoning*`,
 * `.summon-ring*`, `.summon-orb*`, `.summon-spark*`, `.summon-message`, and
 * `.summon-track`/`.summon-fill` classes — those animations are loaded globally
 * with the rest of the landing page CSS.
 *
 * Pass a fresh `message` string to retrigger the React `key` and play the
 * cross-fade animation between rotating messages.
 */
import React from "react";

interface Props {
  message: string;
}

const SummoningAnimation: React.FC<Props> = ({ message }) => (
  <div className="carousel-summoning">
    <div className="carousel-summoning-stage">
      <div className="summon-ring summon-ring-1" />
      <div className="summon-ring summon-ring-2" />
      <div className="summon-ring summon-ring-3" />
      <div className="summon-spinner" />
      <div className="summon-orb">
        <span className="summon-orb-glyph">✦</span>
      </div>
      <span className="summon-spark summon-spark-1" aria-hidden>✦</span>
      <span className="summon-spark summon-spark-2" aria-hidden>◆</span>
      <span className="summon-spark summon-spark-3" aria-hidden>✦</span>
      <span className="summon-spark summon-spark-4" aria-hidden>·</span>
    </div>
    <p key={message} className="summon-message">{message}</p>
    <div className="summon-track">
      <div className="summon-fill" key="generate" />
    </div>
  </div>
);

export default SummoningAnimation;
